export default {
    poweredBy: "Powered by"
}